import React, { useEffect, useState } from 'react';
import OwnerRegistartionCard from './OwnerRegistrationList.jsx'
import OwnerParkinglotRegistration from './OwnerParkinglotRegistration.jsx';
import './OwnerRegistration.css';
import MapDashboard from '../myproporties/MapDashboard';
import { GetUserDetailsFromToken } from '../../Services/employeeService.jsx';

const OwnerDetailsComponent = (props) => {
  const [userDetails] = useState([]);
  const [isEdit, setEdit] = useState();
  const [areasmarked, setAreasmarked] = useState([]);
  const [parkinglotObj, setParkinglotObj] = useState();
  const [defaultaddress, setDefaultaddress] = useState();
  const [editOption, setEditoption] = useState();
  const [salespersonloggedin, setSalespersonloggedin] = useState();
  const [activeMenuId, setActiveMenuId] = useState(null);
  const [employeeId,setEmployeeId] = useState();
  const handleActiveMenuId = (val) => {
    setActiveMenuId(val);
  }

  const handleSetAreasMarked = (newAreas) => {
    setAreasmarked(newAreas);
  };

  const handleSetParkingLotObj = (newParkingLot) => {
    setParkinglotObj(newParkingLot);
  };

  const handleSetDefaultAddress = (newAddress) => {
    setDefaultaddress(newAddress);
  };

  const handleSetEditOption = (newEditOption) => {
    setEditoption(newEditOption);
  };
  const handleSetEdit = (val) => {
    setEdit(val);
  };
  useEffect(() => {
    const fetchUserData = async () => {
        try {
            const userData = await GetUserDetailsFromToken();
            setSalespersonloggedin(userData?.firstName);
            setEmployeeId(userData?.empId);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };
    fetchUserData(); 
  }, []); 
  return (
    <div>
      <div>
        {!isEdit ? (
          <div className='container-fluid p-0'>
            <div className="lotmanagement">
              <div className="row alignLeft">
                <div className="col-7">
                  <div className="viewHeader">
                    <button
                      className="backButton"
                      onClick={props.handleSelectedowner}
                      style={{
                        marginRight: '10px',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      <i className="fas fa-arrow-left"></i>
                    </button>
                    Manage Owners & Properties
                  </div>
                </div>               
              </div>
              {!props.selectedRow && (
                <div className="row alignLeft">
                  <div className="col-12 mb-2">
                    Total Registered Owners: {userDetails?.length}
                  </div>
                </div>
              )}
              <OwnerRegistartionCard
                ownerName={props.selectedRow?.firstName}
                entityName={props.selectedRow?.entityName}
                email={props.selectedRow?.emailId}
                entityId={props.selectedRow?.entityRegistrationID}
                mobilePhone={props.selectedRow?.mobileNumber}
                entityAddress={props.selectedRow?.enityMailingAdderess}
                handleSelectedowner={props.handleSelectedowner}
                propertyOwner={props.propertyOwner}
                handleEdit={props.handleEdit}
                handleDelete={props.handleDelete}
                handleRegsiterOwner={props.handleRegsiterOwner}
                property={props.selectedRow}
                activeMenuId={activeMenuId}
                onActiveMenuIdChange={handleActiveMenuId}
                isEmailPhoneVerified= {props.selectedRow?.isEmailPhoneVerified}
                isEmailVerified= {props.selectedRow?.isEmailVerified}
                isPhoneVerified= {props.selectedRow?.isPhoneVerified}
                isTempPassword= {props.selectedRow?.isTempPassword}
                tandC= {props.selectedRow?.tandC}
                // userId={props.selectedRow?.userId}
                // b2cidowner={props.selectedRow?.userId}
              />
              <OwnerParkinglotRegistration
                entityId={props.selectedRow?.entityRegistrationID}
                onSetAreasMarked={handleSetAreasMarked}
                onSetParkingLotObj={handleSetParkingLotObj}
                onSetDefaultAddress={handleSetDefaultAddress}
                onSetEditOption={handleSetEditOption}
                handleSetEdit={handleSetEdit}
                OwnerDetails={props.selectedRow}
                handleEdit={props.handleEdit}
              />
            </div>
          </div>

        ) : (
          <div><MapDashboard isEdit={isEdit} areasMarked={areasmarked} defaultaddress={defaultaddress} parkinglotObj={parkinglotObj} editOption={editOption} empId={employeeId}
            verifiedBy={salespersonloggedin} userData={props.selectedRow} mapVisibleChangesAlert={props.mapVisibleChangesAlert}
          /></div>
        )}
      </div>
    </div>
  );
};

export default OwnerDetailsComponent;
